<tm-dialog (closeDialog)="closeDialog()"
           (widthChanged)="onPanelWidthChanged($event)"
           [allowResize]="true"
           [dialogTitle]="(activeComponent$ | async)?.dialogTitle || ''"
           [maxWidth]="panelMaxWidth"
           [open]="(activeComponent$ | async) !== null"
           [widthMargin]="panelWidthMargin"
           [width]="panelWidth">
  <ng-content></ng-content>
</tm-dialog>
